import { NumericFormat, type NumberFormatValues } from "react-number-format";
import FormError from "./FormError";

interface FormNumericInputProps {
  label?: string;
  value: number | string | null | undefined;
  onChange: (value: number | null) => void;
  onBlur?: () => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  error?: string;
  errorParams?: Record<string, string | number>;
  decimalScale?: number;
}

export default function FormNumericInput({
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  className = "",
  disabled = false,
  readOnly = false,
  required = false,
  error,
  errorParams,
  decimalScale = 2,
}: FormNumericInputProps) {
  const handleValueChange = (values: NumberFormatValues) => {
    onChange(values.floatValue ?? null);
  };

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-black mb-2">
          {label}
          {required && <span className="text-black ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        <NumericFormat
          value={value ?? ""}
          onValueChange={handleValueChange}
          onBlur={readOnly ? undefined : onBlur}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          decimalSeparator=","
          allowedDecimalSeparators={[",", "."]}
          decimalScale={decimalScale}
          thousandSeparator={false}
          inputMode="decimal"
          className={`
            w-full py-2 text-sm bg-white border rounded-md
            focus:outline-none transition-colors duration-200
            px-3
            ${
              readOnly
                ? "border-gray-200 bg-gray-50 focus:border-gray-200 focus:ring-0 focus:outline-none cursor-default"
                : error
                  ? "border-red-500 focus:ring-2 focus:ring-red-500 focus:border-red-500 cursor-text"
                  : "border-gray-300 hover:border-gray-400 focus:ring-2 focus:ring-primary focus:border-primary cursor-text"
            }
            ${disabled ? "opacity-50 cursor-not-allowed bg-gray-50" : ""}
          `}
        />
      </div>
      <FormError error={error} params={errorParams} />
    </div>
  );
}
